<template>
  <SysDataTableExpand
    id="sys-data-table-evolucao-slow-no-moving"
    :item-height="45"
    class="overflow-x-auto"
    hide-default-footer
    :hide-border-bottom-tr="false"
    :headers="CABECALHOS"
    :callbacks="CALLBACKS"
    :height="alturaDaJanela - 128"
    :item-class="classesCssLinha"
    @callback-executada="rolarParaFimLadoDireito"
    @callback-resetar-grid="fn => callbackResetarGrid = fn"
  >
    <template #top>
      <div class="d-flex align-center w-full justify-space-between pt-1 pb-2">
        <div class="d-flex align-center mr-1">
          <span class="font-20 font-weight-medium text-systock-blue">Evolução Slow-no Moving</span>

          <v-divider vertical class="mx-4" />

          <Filtros v-model="filtros_basicos" />

          <FiltroPeriodoAnalise
            v-if="datas_cabecalhos && datas_cabecalhos.length > 0"
            :data_inicial_atual="datas_cabecalhos[0]"
            :data_final_atual="datas_cabecalhos[datas_cabecalhos.length - 1]"
            @update:periodo-analise="callbackResetarGrid()"
          />
        </div>

        <ComparacaoEntreDatas class="mr-n1" :datas_comparacao="datas_comparacao" :dados_linha="totais" />
      </div>
    </template>

    <template #_item.descricao_linha="{item}">
      <div class="d-flex align-center text-left">
        <DetalhesProduto
          v-if="item.idproduto && !item.produto_combinado"
          :produto="{ id_grupo: item.idgrupo, id_filial: 9999, id_produto: item.idproduto}"
        />
        <div class="w-280 text-truncate" :title="item.descricao_linha" v-text="item.descricao_linha" />
      </div>
    </template>

    <template v-for="(data, key) in datas_cabecalhos" #[`header.${data}`]>
      <SelecionarDatasParaComparacao
        v-model="datas_comparacao"
        :key="key"
        :data_atual="data"
        :outras_datas="datas_cabecalhos.filter(value => value !== data)"
      />
    </template>

    <template v-for="(data, key) in datas_cabecalhos" #[`item.${data}`]="{item}">
      <Celula :key="key" :item="item" :data="data" :filtros_basicos="filtros_basicos" />
    </template>
  </SysDataTableExpand>
</template>

<script>
import {componentes} from "./Componentes";
import ResponsiveHeight from "../../../../../helpers/ResponsiveHeight";
import * as api from "../../../../../api/Diagnostico/SlowNoMoving/IndicadorEvolucaoSlowNoMoving";
import {cabecalho_histograma, map_data_para_cabecalho_grid} from "./Cabecalhos";

export default {
  name: 'Tabela',
  components: componentes,
  mixins: [ResponsiveHeight],
  data: () => ({
    datas_cabecalhos: new Array(12).fill("00/00/0000"),
    callbackResetarGrid: null,
    filtros_basicos: {
      segmentos: [],
      compradores: [],
      fornecedores: [],
      produtos: [],
      status_produto: [],
      histogramas: [],
    },
    totais: {
      "00/00/0000": 0
    },
    datas_comparacao: {
      data_inicial: "00/00/0000",
      data_final: "00/00/0000",
    }
  }),
  computed: {
    CALLBACKS() {
      const funcoes = [
        this.buscarHistogramas,
        this.buscarSegmentos,
        this.buscarFornecedores,
        this.buscarProdutos,
      ];

      if (localStorage.diagnostico_ocultar_nivel_fornecedor === 'S') {
        return funcoes.filter(f => f !== this.buscarFornecedores);
      }

      return funcoes;
    },
    CABECALHOS() {
      return [cabecalho_histograma, ...this.datas_cabecalhos.map(map_data_para_cabecalho_grid)];
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    FILTROS_GERAIS() {
      return  {...this.filtros_basicos, ...this.FILTROS_STORE};
    }
  },
  watch: {
    FILTROS_GERAIS() {
      this.callbackResetarGrid();
    }
  },
  methods: {
    gerarValoresTotalizados(itens) {
      const callback = (a, b) => {
        this.datas_cabecalhos.forEach(data => (a[data] = (a[data] || 0) + Number(b[data])))
        return a;
      };

      return {
        ...itens.reduce(callback, {}),
        totalizador: true,
        descricao_linha: "Total Geral",
        $nao_expansivel: true,
      }
    },
    formatarItensParaGrid(itens) {
      const callback = item => {
        const $nao_expansivel = !this.datas_cabecalhos.some(data => Number(item[data]) > 0);
        return {...item, $nao_expansivel}
      };
      return itens.map(callback);
    },
    setDatasComparacaoPadrao() {
      if (!this.datas_cabecalhos || this.datas_cabecalhos.length <= 1) return;
      this.datas_comparacao.data_inicial = this.datas_cabecalhos[0];
      this.datas_comparacao.data_final = this.datas_cabecalhos[this.datas_cabecalhos.length - 1];
    },
    async buscarHistogramas() {
      const {histogramas, datas_distintas} = await api.buscarHistogramas(this.FILTROS_GERAIS);

      if (!datas_distintas || datas_distintas.length === 0) return [];

      this.datas_cabecalhos = datas_distintas;
      this.setDatasComparacaoPadrao();
      this.totais = this.gerarValoresTotalizados(histogramas);

      return [this.totais, ...this.formatarItensParaGrid(histogramas)];
    },
    async buscarSegmentos({descricao_linha: histograma}) {
      const parametros = {...this.FILTROS_GERAIS, histograma};
      return this.formatarItensParaGrid(await api.buscarSegmentos(parametros));
    },
    async buscarFornecedores(linha) {
      if (linha.descricao_linha === 'COMBINADOS') {
        linha.produto_combinado = true;
        return await this.buscarProdutos(linha);
      }

      const parametros = {
        ...this.FILTROS_GERAIS,
        histograma: linha.histograma,
        segmentos: [linha.idsegmento]
      };

      return this.formatarItensParaGrid(await api.buscarFornecedores(parametros));
    },
    async buscarProdutos(linha) {
      const parametros = {
        ...this.FILTROS_GERAIS,
        histograma: linha.histograma,
        segmentos: [linha.idsegmento],
        fornecedores: linha.idfornecedor ? [linha.idfornecedor] : [],
        produto_combinado: linha.produto_combinado ? 'S' : 'N'
      };

      const itens = this.formatarItensParaGrid(await api.buscarProdutos(parametros));

      return itens.map(item => ({
        ...item,
        produto_combinado: linha.produto_combinado,
        $nao_expansivel: linha.produto_combinado,
      }));
    },
    async rolarParaFimLadoDireito() {
      await this.$nextTick();
      const el = document.querySelector("#sys-data-table-evolucao-slow-no-moving")
        .querySelector('#sys-data-table-body');
      if (el) el.scrollLeft = el.scrollWidth - el.clientWidth;
    },
    classesCssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'font-weight-bold-hover': true
      };
    }
  }
}
</script>

<style scoped>
</style>
